export const HomeReservationContent = {
  heading: "THE PERFECT PLACE FOR ANY OCCASION",
  text: `Explore a multi-cuisine menu crafted for every craving—Indian classics, smoky Tandoor delights, bold Chinese flavors, and elegant Continental favorites.
  From comforting family meals to fine-dining signatures, each dish is made with premium ingredients, authentic techniques, and unforgettable taste.`,
  buttonText: "Make a Reservation",
  video: "./images/ambience-fit.mp4",
  popupTitle: "Reservation",
  popupText: "Please call to book your table +91 7814244386 or +91 7009037495.",
};
